import {
  $post, $get, $JsonPost, ebopo,
} from '@/utils/axios-request';


const base = '';
class Read {
  // 词汇登录
  public async queryRedReadIndexData(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/redread/api/v1/queryRedReadIndexData`, postData);
  }

  // 获得学习单元的题目等内容（学习）
  public async gotoStudyReadUnit(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/redread/api/v1/gotoStudyReadUnit`, postData);
    // return await $JsonPost( ebopo+'/redread/api/v1/queryRedReadIndexData', postData);
  }

  // 提交答案
  public async saveOption(postData: any): Promise<any> {
    console.log(postData);
    return await $post(`${ebopo}/redread/api/v1/saveOption`, postData);
  }

  // 排行榜-(班级)--显示最多20条
  public async queryLeaderboard(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/redread/api/v1/queryLeaderboard`, postData);
  }

  // 学习记录列表查询支持时间的筛选
  public async queryStudyRecordList(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/redread/api/v1/queryStudyRecordList`, postData);
  }

  //  查询竞赛结果列表
  public async queryCompetitionRecordVoList(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/sportsread/api/v1/queryCompetitionRecordVoList`, postData);
  }

  //  学力分析
  public async queryAcademicAnalysis(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/sportsread/api/v1/queryAcademicAnalysis`, postData);
  }

  //  查询擂台列表
  public async queryPlatformList(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/sportsread/api/v1/queryPlatformList`, postData);
  }

  //  查询对战列表
  public async queryBattle(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/sportsread/api/v1/queryBattle`, postData);
  }

  //  查询单元内的文章列表,通过的需要显示查询解析的按钮
  public async queryDocListByUnitId(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/redread/api/v1/queryDocListByUnitId`, postData);
  }

  //  查询课程内的单元列表
  public async queryUnitListByCourseId(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/redread/api/v1/queryUnitListByCourseId`, postData);
  }

  //  查询阅读指导的列表
  public async queryReadingGuideList(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/redread/api/v1/queryReadingGuideList`, postData);
  }

  // 查询阅读指导内容
  public async queryReadingGuideListDocByDocId(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/redread/api/v1/queryReadingGuideListDocByDocId`, postData);
  }

  // 查看文章解析
  public async queryUserAnalysisDocByDocId(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/redread/api/v1/queryUserAnalysisDocByDocId`, postData);
  }

  // 摆擂
  public async saveQueryPlatform(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/sportsread/api/v1/saveQueryPlatform`, postData);
  }

  // 撤擂
  public async deleteQueryPlatform(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/sportsread/api/v1/deleteQueryPlatform`, postData);
  }

  // 攻擂
  public async attackPlatform(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/sportsread/api/v1/attackPlatform`, postData);
  }

  // 拒绝对战
  public async refuseBattle(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/sportsread/api/v1/refuseBattle`, postData);
  }

  // 接受对战
  public async iAcceptBattle(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/sportsread/api/v1/iAcceptBattle`, postData);
  }

  // 发起对战
  public async initiateBattle(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/sportsread/api/v1/initiateBattle`, postData);
  }

  // 查看是否有挑战我的擂台
  public async isHasArena(): Promise<any> {
    return await $get(`${ebopo}/sportsread/api/v1/queryMyLeiTaiInfo`);
  }

  // 挑战我的列表
  public async queryMyBattle(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/sportsread/api/v1/queryMyBattle`, postData);
  }
}
export default new Read();
